<div class="progress_in_background" *ngIf="number_of_record_processed>0">
  <div class="pie-chart me-3" [ngStyle]="pie_chart_width_value">
    <div class="label">
      <div class="d-flex align-items-baseline">
        <p class="num_rec m-0">
          {{processed_percentage}}%
        </p>
      </div>
    </div>
  </div>
  <div style="margin-right: 40px;">
    <p class="txt1">Accounts Receivable</p>
    <p class="txt2">Data is being processed</p>
  </div>
  <div>
    <img src="assets/img/svg/arrow_right_black.svg" alt="">
  </div>
</div>